<!-- SELECT TAG CONTENT- -->
<div
  *ngIf="viewMode === 'TAGCONTAINER'"
  class="tag-notification-dialog-container"
>
  <h1 mat-dialog-title class="dialog-title">
    Select Tags
  </h1>
  <mat-dialog-content>
    <div class="tag-notification-dialog-action">
      <div class="tag-notification-device">
        <mat-radio-group name="notification-action" [(ngModel)]="pushOption">
          <mat-radio-button value="1">Send to All devices</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="notification-by-tag">
        <mat-radio-group name="notification-action" [(ngModel)]="pushOption">
          <mat-radio-button value="2">Select by tags</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div
      class="notification-send-all-action align-h"
      *ngIf="pushOption === '2'"
    >
      <div class="stretch">
        <a mat-flat-button (click)="onSelectTags()">
          Select All
        </a>
      </div>
      <a mat-flat-button (click)="onClearTags()">
        Clear All
      </a>
    </div>
    <div class="notification-tag-list" *ngIf="pushOption === '2'">
      <mat-progress-bar
        mode="indeterminate"
        *ngIf="!tagList"
      ></mat-progress-bar>
      <mat-checkbox
        *ngFor="let item of tagList"
        [checked]="tagSelection.isSelected(item)"
        (change)="$event ? tagSelection.toggle(item) : null"
      >
        {{ item.tagName }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      tabindex="-1"
      mat-raised-button
      color="basic"
      class="mat-button-medium"
      mat-dialog-close
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mat-button-medium"
      [disabled]="tagSelection.selected?.length === 0 && pushOption != '1'"
      (click)="onDoneTag()"
    >
      Done
    </button>
  </mat-dialog-actions>
</div>

<!-- CONFIRM AND SEND CONTENT- -->
<div
  *ngIf="viewMode === 'CONFIRMANDSENDCONTAINER'"
  class="tag-notification-dialog-container"
>
  <h1 mat-dialog-title class="dialog-title">
    Confirm and Send
  </h1>
  <mat-dialog-content>
    <div class="tag-notification-dialog-action">
      <div class="tag-notification-device">Selected Push Notification</div>
      <div class="confirm-send-change-action">
        <a mat-flat-button mat-dialog-close>
          Change
        </a>
      </div>
    </div>
    <div class="confirm-and-send">
      <div class="confirm-and-send-image-item">
        <img
          *ngIf="slectedTagInfo?.imageUrl"
          src="{{ slectedTagInfo?.imageUrl }}"
          [attr.alt]="slectedTagInfo?.title"
        />
      </div>
      <div class="confirm-and-send-text-item">
        <h4>{{ slectedTagInfo?.title }}</h4>
        <p>{{ slectedTagInfo?.description }}</p>
        <p>{{ slectedTagInfo?.link }}</p>
      </div>
    </div>
    <div
      class="tag-notification-dialog-action"
      *ngIf="tagSelection.selected?.length > 0"
    >
      <div class="tag-notification-device">Selected Tag</div>
      <div class="confirm-send-change-action">
        <a mat-flat-button (click)="addTag()">
          Add Tag
        </a>
      </div>
    </div>
    <div class="confirm-notification-tags-item">
      <div class="confirm-notification-tags">
        <mat-chip-list>
          <mat-chip
            color="primary"
            *ngFor="let tag of tagSelection.selected"
            (removed)="tagSelection.toggle(tag)"
          >
            {{ tag.tagName }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      tabindex="-1"
      mat-raised-button
      color="basic"
      class="mat-button-medium"
      (click)="closeConfirmView()"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mat-button-medium"
      (click)="onSendNotification(tagSelection.selected)"
    >
      Send
    </button>
  </mat-dialog-actions>
</div>
